import React, { useState, useEffect } from 'react';
import api from './api';

const SalesHistory = () => {
    const [sales, setSales] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSales = async () => {
        try {
            const res = await api.get('/sales');
            setSales(res.data);
            setLoading(false);
        } catch (err) { setLoading(false); }
    };

    useEffect(() => { fetchSales(); }, []);

    const totalSoldAmt = sales.reduce((acc, s) => acc + s.finalAmount, 0);
    const totalProfit = sales.reduce((acc, s) => acc + (s.profitAmount || 0), 0);
    
    const formatNumber = (num) => (num || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    return (
        <div className="container mt-4 mb-5">
            <h4 className="fw-bold mb-3">Sales History (Sold Book)</h4>

            {/* PROFIT STATS */}
            <div className="row mb-4 g-2">
                <div className="col-6 col-md-4">
                    <div className="card bg-success text-white p-2 text-center h-100">
                        <small>Total Sales</small>
                        <h4 className="mb-0">₹ {Math.round(totalSoldAmt).toLocaleString()}</h4>
                    </div>
                </div>
                <div className="col-6 col-md-4">
                    <div className={`card text-white p-2 text-center h-100 ${totalProfit >= 0 ? 'bg-primary' : 'bg-danger'}`}>
                        <small>Net Profit</small>
                        <h4 className="mb-0">₹ {Math.round(totalProfit).toLocaleString()}</h4>
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <div className="card bg-light border p-2 text-center h-100">
                        <small>Total Invoices</small>
                        <h4 className="mb-0">{sales.length}</h4>
                    </div>
                </div>
            </div>

            {/* TABLE */}
            <div className="card shadow-sm border-0">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead className="table-dark">
                            <tr>
                                <th>Date</th>
                                <th>Buyer</th>
                                <th>Lot No</th>
                                <th className="text-end">Weight</th>
                                <th className="text-end">Sale Rate</th>
                                <th className="text-end">Amount</th>
                                <th className="text-end">Profit</th>
                                <th className="text-center">Paid?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? <tr><td colSpan="8" className="text-center p-3">Loading...</td></tr> : 
                             sales.map(s => (
                                <tr key={s._id}>
                                    <td>{new Date(s.saleDate).toLocaleDateString('en-GB')}</td>
                                    <td>
                                        <div className="fw-bold text-primary">{s.buyer?.companyName}</div>
                                        <small className="text-muted">{s.saleId}</small>
                                    </td>
                                    <td className="fw-bold">{s.rpNumber}</td>
                                    <td className="text-end">{formatNumber(s.weight)}</td>
                                    <td className="text-end">{formatNumber(s.saleRate)}</td>
                                    <td className="text-end fw-bold">{formatNumber(s.finalAmount)}</td>
                                    
                                    {/* Profit Column */}
                                    <td className={`text-end fw-bold ${s.profitAmount >= 0 ? 'text-success' : 'text-danger'}`}>
                                        {formatNumber(s.profitAmount)}
                                    </td>

                                    <td className="text-center">
                                        <span className={`badge ${s.paymentStatus === 'Paid' ? 'bg-success' : 'bg-warning text-dark'}`}>
                                            {s.paymentStatus}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SalesHistory;